export default __webpack_public_path__ + "static/media/icon-checkmark-hover-dark.851f0d53.svg";